if (!customElements.get('ecomhard-reviews-slider')) {
  class EcomhardReviewsSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.onBlockSelect = this.onBlockSelect.bind(this);
    }

    connectedCallback() {
      this.initSlider();

      if (Shopify.designMode) {
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.onBlockSelect);

      if (this.slider && !this.slider.destroyed) {
        this.slider.destroy(true, true);
      }
    }

    initSlider() {
      if (typeof Swiper === 'undefined') {
        window.setTimeout(() => this.initSlider(), 80);
        return;
      }

      if (this.slider && !this.slider.destroyed) {
        this.slider.destroy(true, true);
      }

      const section = this.closest('[data-ecomhard-reviews-section]');
      const mobileSlides = Number.parseFloat(this.dataset.slidesMobile) || 1;
      const desktopSlides = Number.parseFloat(this.dataset.slidesDesktop) || 3;
      const gap = Number.parseFloat(this.dataset.gap) || 0;
      const showNavigation = this.dataset.showNavigation === 'true';

      const options = {
        a11y: false,
        threshold: 3,
        slidesPerView: mobileSlides,
        spaceBetween: gap,
        resistanceRatio: 0.72,
        watchOverflow: true,
        breakpoints: {
          750: {
            slidesPerView: desktopSlides,
            spaceBetween: gap
          }
        }
      };

      if (showNavigation && section) {
        const prevEl = section.querySelector('[data-ecomhard-review-prev]');
        const nextEl = section.querySelector('[data-ecomhard-review-next]');

        if (prevEl && nextEl) {
          options.navigation = { prevEl, nextEl };
        }
      }

      this.slider = new Swiper(this, options);

      if (this.slider?.wrapperEl) {
        this.slider.wrapperEl.setAttribute('aria-live', 'polite');
        this.slider.wrapperEl.id = `ecomhard-reviews-wrapper-${this.dataset.sectionId}`;

        this.slider.slides.forEach((slide, index) => {
          slide.setAttribute('role', 'group');
          slide.setAttribute('aria-label', `${index + 1} / ${this.slider.slides.length}`);
          slide.dataset.index = index;
        });
      }
    }

    onBlockSelect(event) {
      const selectedBlock = event.target.closest('[data-review-block-id]');
      if (!selectedBlock || !this.contains(selectedBlock) || !this.slider) return;

      const index = Array.from(this.querySelectorAll('[data-review-block-id]')).indexOf(selectedBlock);
      if (index >= 0) this.slider.slideTo(index, 300);
    }
  }

  customElements.define('ecomhard-reviews-slider', EcomhardReviewsSlider);
}
